import Heartbeat from './presentational'
import { connect } from 'react-redux'
import { heartbeatRequest } from 'store/ducks/heartbeat'

const mapStateToProps = (state) => ({
  profile: state.profile.payload,
})

const mapDispatchToProps = (dispatch, props) => ({
  sendBeat: () => dispatch(heartbeatRequest()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Heartbeat)
